import { SVG, SVGProps } from './svg'

export function IconDiamondOutlined(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="m17.59 3.65 4.15 4.51a1 1 0 0 1 .26.68v.3a1 1 0 0 1-.23.64l-9 10.86a1 1 0 0 1-1.54 0l-9-10.86A1 1 0 0 1 2 9.14v-.3c0-.25.1-.5.26-.68l4.15-4.51A2 2 0 0 1 7.88 3h8.24a2 2 0 0 1 1.47.65ZM9.22 9.7 12 18.46 19.79 9h-6.16a.5.5 0 0 1-.37-.84L16.12 5H7.88L4.21 9h4.01a1 1 0 0 1 1 .7Z"
      />
    </SVG>
  )
}
